module.exports = __webpack_public_path__ + "static/img/login.b742f41.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login.png
// module id = Uwr+
// module chunks = 79